import FLATTEN from "@/classes/flatten.js";
var boxLineList = [];

// 已知盒子中心点和发送位置的中心点 发送射线
export function emissionLine(centerList, lineList) {
    var lineAll = {};
    var lineRightList = [];
    // 使用map函数将[x:1,y:2]转换数组[1,2]
    var boxCenter = centerList.map((item) => [item.x, item.y]);
    var boxLine = lineList.map((item) => [item.x, item.y]);
    for (let i = 0; i < boxCenter.length; i++) {
        let pa = FLATTEN.point(
            Number(boxCenter[i][0]),
            Number(boxCenter[i][1])
        );
        let pb = FLATTEN.point(Number(boxLine[i][0]), Number(boxLine[i][1]));
        lineAll = FLATTEN.line(pa, pb);
        boxLineList.forEach((e) => {
            // 画线
            let jd = lineAll.intersect(e.segment); // 求交点
            if (jd.length > 0) {
                console.log(e, "交点");
                // 有交点
                if (e.segment.pe.x > pb.x) {
                    // 右边
                    lineRightList.push(e);
                }
            }
        });
    }
    return lineRightList;
}

// 利用BOX框每一个数据项
export function boxCoordinate(OCRObj) {
    var p1 = "";
    var p2 = "";
    var p3 = "";
    var p4 = "";
    boxLineList = [];
    OCRObj.forEach((res, index) => {
        p1 = `${Number(res[0][0][0])},${Number(res[0][0][1])}`;
        p2 = `${Number(res[0][1][0])},${Number(res[0][1][1])}`;
        p3 = `${Number(res[0][2][0])},${Number(res[0][2][1])}`;
        p4 = `${Number(res[0][3][0])},${Number(res[0][3][1])}`;
        let boxLine = FLATTEN.box(p1, p2, p3, p4);
        let segment1 = FLATTEN.segment(
            Number(res[0][0][0]),
            Number(res[0][0][1]),
            Number(res[0][2][0]),
            Number(res[0][2][1])
        );
        // segment1.ps = p1;
        // segment1.pe = p2;
        // let segment2 = FLATTEN.segment(p1,p3)
        boxLine.msg = {
            value: res[1][0],
        };
        let segmentObj = {};
        segmentObj.segment = segment1;
        segmentObj.msg = res[1][0];
        // segment1.msg = res[1][0]
        // segment2.msg = res[1][0]
        boxLineList.push(segmentObj);
        // boxLineList.push(segment2)
        // console.log(boxLine, res, "p1, p2, p3, p4p1, p2, p3, p4");
    });
}
//盒子坐标
export function lineCoordinate(res) {
    var p1 = "";
    var p2 = "";
    var p3 = "";
    var p4 = "";
    var boxCenter = [];
    var boxLine = [];
    p1 = `${Number(res[0][0])},${Number(res[0][1])}`;
    p2 = `${Number(res[1][0])},${Number(res[1][1])}`;
    p3 = `${Number(res[2][0])},${Number(res[2][1])}`;
    p4 = `${Number(res[3][0])},${Number(res[3][1])}`;
    let aa = FLATTEN.box(p1, p2, p3, p4);
    console.log(aa, "p1, p2, p3, p4");
    // let boxline = FLATTEN.line();
    // 使用map函数将[x:1,y:2]转换数组[1,2]
    // .map(item => [item.x, item.y])
    boxCenter.push(
        getCenterPoint(
            convertArrayToObject(res[0]),
            convertArrayToObject(res[1]),
            convertArrayToObject(res[2]),
            convertArrayToObject(res[3])
        )
    );
    boxLine.push(
        getCenterLine(
            convertArrayToObject(res[1]),
            convertArrayToObject(res[2])
        )
    );
    console.log(
        getCenterLine(
            convertArrayToObject(res[1]),
            convertArrayToObject(res[2])
        ),
        "p1, p2, p3, p4p1, p2, p3, p4"
    );
    return emissionLine(boxCenter, boxLine);
    // boxCenter.map(item => [item.x, item.y])
    // console.log(boxCenter, boxLine, "boxlineboxlineboxlineboxlineboxline");
}
//转换坐标格式
export function convertArrayToObject(arr) {
    if (arr.length !== 2) {
        throw new Error("The array must have exactly 2 elements");
    }
    return {
        x: arr[0],
        y: arr[1],
    };
}

// 查找坐标点
export function seekPosIndex(indexes) {
    for (let i = 0; i < indexes.length; i++) {
        if (i === 1) {
            // 第二个元素（索引为1）
            indexes[i] -= 1;
        }
    }
    indexes.pop();
    return indexes; // 直接将索引为1的元素减1,并去掉最后一位
}
export function formatDate(dateString) {
    // 使用正则表达式解析日期字符串
    const regex = /^(\d{4})年(\d{2})月(\d{2})日$/;
    const matches = regex.exec(dateString);

    if (matches) {
        // 如果匹配成功，返回格式化后的日期字符串
        return `${matches[1]}-${matches[2]}-${matches[3]}`;
    } else {
        // 如果匹配失败，返回原始字符串或错误消息
        return dateString; // 或者你可以抛出一个错误
    }
}

// 递归访问数组
export function getValueByIndices(array, indices, currentIndex = 0) {
    //利用数组下标在多层数组中取相应的值
    if (currentIndex >= indices.length) {
        // 如果已经访问完所有下标，返回当前数组（或数组的第一个元素，取决于你的需求）
        return array; // 或者返回 array，或根据需求进行其他处理
    }

    const index = indices[currentIndex];
    if (Array.isArray(array) && index >= 0 && index < array.length) {
        // 如果当前数组存在且下标有效，则递归访问下一层
        return getValueByIndices(array[index], indices, currentIndex + 1);
    }

    // 如果下标无效或当前不是数组，则返回undefined或抛出错误
    return undefined; // 或者 throw new Error('Invalid index or not an array');
}
export function getAfterColon(str, A) {
    // 截取冒号后的字符并返回
    const parts = str.split(A);
    console.log(parts, "parts");
    if (parts.length > 1) {
        return parts.slice(1).join(A); // 如果存在多个冒号，这将返回冒号后的所有内容
    }
    return ""; // 如果没有找到冒号，返回空字符串
}
// 精准查找
export function findAllIndexesJ(arr, target, parentIndex = [], result = []) {
    // 递归数组匹配字符并返回深度坐标
    arr.forEach((value, index) => {
        // 计算当前元素的完整索引（如果它是嵌套数组的话）
        const currentIndex = parentIndex.length
            ? [...parentIndex, index]
            : [index];
        // value.includes(target))
        if (
            typeof value === "string" &&
            value.replace("￥", "¥") == target.replace("￥", "¥")
        ) {
            // 如果当前值是字符串且包含目标字符串，则将完整索引添加到结果数组中
            result.push(currentIndex);
        } else if (Array.isArray(value)) {
            // 如果当前值是数组，则递归查找
            findAllIndexesJ(value, target, currentIndex, result);
        }
    });
    // 递归调用后，直接返回结果（不需要再次返回，因为result是引用类型）
    return result;
}
// 模糊查找
export function findAllIndexesM(arr, target, parentIndex = [], result = []) {
    // 递归数组匹配字符并返回深度坐标
    arr.forEach((value, index) => {
        // 计算当前元素的完整索引（如果它是嵌套数组的话）
        const currentIndex = parentIndex.length
            ? [...parentIndex, index]
            : [index];
        // value.includes(target))
        if (typeof value === "string" && value.includes(target)) {
            // 如果当前值是字符串且包含目标字符串，则将完整索引添加到结果数组中
            result.push(currentIndex);
        } else if (Array.isArray(value)) {
            // 如果当前值是数组，则递归查找
            findAllIndexesM(value, target, currentIndex, result);
        }
    });
    // 递归调用后，直接返回结果（不需要再次返回，因为result是引用类型）
    return result;
}
// 求盒子的的中心点
export function getCenterPoint(p1, p2, p3, p4) {
    // 假设p1, p2, p3, p4是角的坐标，例如 {x: 1, y: 1}
    const xValues = [p1.x, p2.x, p3.x, p4.x];
    const yValues = [p1.y, p2.y, p3.y, p4.y];

    const centerX = (Math.max(...xValues) + Math.min(...xValues)) / 2;
    const centerY = (Math.max(...yValues) + Math.min(...yValues)) / 2;

    return { x: centerX, y: centerY };
}
// 求边的中心点
export function getCenterLine(p2, p3) {
    // 假设 p2, p3是角的坐标，例如 {x: 1, y: 1}
    const xValues = [p2.x, p3.x];
    const yValues = [p2.y, p3.y];

    const centerX = (Math.max(...xValues) + Math.min(...xValues)) / 2;
    const centerY = (Math.max(...yValues) + Math.min(...yValues)) / 2;

    return { x: centerX, y: centerY };
}